import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { MdExpandMore } from 'react-icons/md';
import { Ticket } from '../../../../../models/Ticket';
import { Exercise } from '../../../../../models/Exercise';
import SingleReservation from '../../ReservationsTab/SingleReservation';
import EAButton from '../../../../shared/Buttons/EAButton';
import { isAfter, startOfDay } from "date-fns";

interface IProps {
  pass: Ticket;
  onRefreshTickets?: () => void;
}

const DetailsExercises: React.FC<IProps> = ({ pass, onRefreshTickets }) => {
  const { t } = useTranslation();
  const [showHistory, setShowHistory] = useState(false);

  // Nadchodzące = od dzisiaj 00:00 w przyszłość, reszta to historia (od najnowszej)
  const isUpcoming = (exercise: Exercise): boolean => {
    const today = startOfDay(new Date());
    const exerciseDate = new Date(exercise.startTime);
    return isAfter(exerciseDate, today) || exerciseDate.getTime() === today.getTime();
  };

  const exercises = pass.exercises ?? [];
  const upcomingExercises = exercises.filter(isUpcoming);
  const pastExercises = exercises.filter((exercise) => !isUpcoming(exercise)).sort((a, b) => b.startTime - a.startTime);

  return (
    <div className="ticket-details__exercises-section">
      <h5>
        {t("nadchodzace_rezerwacje")} ({upcomingExercises.length})
      </h5>

      {upcomingExercises.length > 0 ? (
        <div className="ticket-details__exercises-list">
          {upcomingExercises.map((exercise, index) => (
            <div key={index} className="ticket-details__exercise-item">
              <SingleReservation
                ticket={pass}
                exercise={exercise}
                onRefreshTickets={onRefreshTickets}
                variant="minimal"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="body-text-small text-color-light-gray">{t("brak_nadchodzacych_rezerwacji")}</p>
      )}

      {pastExercises.length > 0 && (
        <>
          <div className="ticket-details__history-toggle">
            <EAButton
              title={`${t("historia_rezerwacji")} (${pastExercises.length})`}
              variant="text"
              compact
              noMargins
              endIcon={<MdExpandMore style={showHistory ? { transform: "rotate(180deg)" } : undefined} />}
              onClick={() => setShowHistory((prev) => !prev)}
            />
          </div>
          {showHistory && (
            <div className="ticket-details__exercises-list">
              {pastExercises.map((exercise, index) => (
                <div key={index} className="ticket-details__exercise-item">
                  <SingleReservation
                    ticket={pass}
                    exercise={exercise}
                    onRefreshTickets={onRefreshTickets}
                    variant="minimal"
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Podsumowanie pozostałych zapisów
      <EAAlert type="success" message={`${t("pozostalo_do_wykorzystania")}: ${remainingEntrances}/${pass.entrances}`} /> */}
    </div>
  );
};

export default DetailsExercises;
